export class SendData {
    option: any;
    cam: any;
}